export const LOCALSTORAGE_THEME_KEY = "theme";

export const DOCS_CLIPBOARD_COPY_ERROR_PATH =
  "/overview/faq#1-“failed-to-copy-alert%2Ffingerprint-please-check-your-browser-permissions”";
